const PaginationConstants = {
  ITEMS_PER_PAGE: 20
};

export default PaginationConstants;
